<template>
	<unit-icon
		:unitType="$props[metricSchema.unitId.key]"
		edgeSize="20"
	/>&nbsp;
	{{ $props[metricSchema.value.key] ? 'Відновлення:' : 'Аварія:' }}
	<span :class="{
		'text-success': $props[metricSchema.value.key],
		'text-danger': !$props[metricSchema.value.key],
	}">
		{{ capitalizeFirstLetter(Station.failureTitle($props[metricSchema.metricId.key])) }}
	</span>
</template>



<script>
import UnitIcon from '@/components/Icons/UnitIcon.vue'
import { capitalizeFirstLetter } from '@/helpers.js'
import {
	eventSchema,
 } from '@/composables/events.js'
import { metricSchema } from '@/composables/metricHistory.js'
import { Station } from '@/models/station.js'


export default {
	components: {
		UnitIcon,
	},
	
	props: {
		[metricSchema.metricId.key]: {
			type: String,
			required: true,
		},

		[metricSchema.stationId.key]: {
			type: String,
			required: true,
		},

		[metricSchema.time.key]: {
			type: Date,
			required: true,
		},

		[metricSchema.unitId.key]: {
			type: String,
			required: true,
		},

		[metricSchema.value.key]: {
			type: [String, Boolean, Number],
			required: true,
		},
	},

	setup() {
		return {
			capitalizeFirstLetter,
			eventSchema,
			metricSchema,
			Station,
		}
	},

	methods: {},

	computed: {},
}
</script>